import React from 'react';
import { COPILOT_PANEL_WIDTH } from '@components/Copilot/constants';
import { AiMagic } from '@fabric-ui/icons';
import { Box } from '@mui/material';
import { cn } from '@utils/cn';

interface IDefaultPromptItem {
  prompt: string;
  onClick: () => void;
  disabled?: boolean;
}

const DefaultPromptItem: React.FC<IDefaultPromptItem> = ({ prompt, onClick, disabled = false }) => (
  <Box
    onClick={disabled ? undefined : onClick}
    className={cn(
      'flex w-full items-start gap-[4px] rounded-xl border-2 border-border-base-primary px-3 py-4',
      'break-words transition-shadow duration-100',
      disabled ? 'cursor-default opacity-50' : 'cursor-pointer hover:bg-surface-elevated-10 hover:shadow-secondary-md'
    )}
    style={{ maxWidth: COPILOT_PANEL_WIDTH - 48 }}>
    <AiMagic />
    {prompt}
  </Box>
);

const MemoizedDefaultPromptItem = React.memo(DefaultPromptItem, (oldProps, newProps) => oldProps.prompt === newProps.prompt);

export default MemoizedDefaultPromptItem;
